@let selectedTariffs = this.selectedTariffs();
@let stromOrGasProductsWithoutTariffs = this.stromOrGasProductsWithoutTariffs();
@let fernwaermeProducts = this.fernwaermeProducts();
@let contractInfos = this.contractInfos();
@let hasMatchingPriceSheets = this.hasMatchingPriceSheets();

@let hasSelectedTariffs = selectedTariffs?.length > 0;
@let hasStromOrGasProductsWithoutTariffs = stromOrGasProductsWithoutTariffs?.length > 0;
@let hasStromOrGasProducts = hasSelectedTariffs || hasStromOrGasProductsWithoutTariffs;
@let hasFernwaermeProducts = fernwaermeProducts?.length > 0;
@let hasContractInfos = contractInfos?.length > 0;

<mwe-address [address]="address()" />

<div class="mt-lg-6 mt-5">
  @if (hasStromOrGasProducts || hasFernwaermeProducts) {
    @if (hasStromOrGasProducts) {
      <h2 class="mb-lg-5 mb-4" data-test="relocation-summary-register-stromGas-title">
        {{ 'relocation.summary.register.stromGasTitle' | translate }}
      </h2>
    }

    @if (hasSelectedTariffs) {
      <div class="row gap-lg-0 gap-3">
        <mwe-tariff-selection-container [selectedTariffs]="selectedTariffs" [isReadOnly]="true" class="d-block mb-4" />
      </div>
    }

    @if (hasStromOrGasProductsWithoutTariffs) {
      <div class="row gy-4">
        @for (product of stromOrGasProductsWithoutTariffs; track $index) {
          <div class="col-12 col-lg-6">
            <mwe-basic-card>
              <mwe-wizard-product-card
                [product]="product"
                [tarifKey]="product.tarifKey"
                [tariffClasses]="product.tariffClasses"
                [showTariffDetailsLink]="hasMatchingPriceSheets"
              />
            </mwe-basic-card>
          </div>
        }
      </div>
    }

    @if (voucherInfo()) {
      <div class="mb-4">
        <mwe-benefits-card [voucherInfo]="voucherInfo()" />
      </div>
    }

    @if (hasFernwaermeProducts) {
      <h2 class="mb-3 {{ hasStromOrGasProducts ? 'mt-4 mt-lg-5' : '' }}" data-test="relocation-summary-register-fernwaerme-title">
        {{ 'relocation.summary.register.fernwaermeTitle' | translate }}
      </h2>

      <p class="mb-5" [innerHTML]="'relocation.summary.register.fernWaermeDescription' | translate: fernWaermePlaceholderRecord()"></p>

      <div class="row gap-lg-0 gap-3">
        @for (product of fernwaermeProducts; track product) {
          <div class="col col-lg-6">
            <div class="row g-3 mb-6">
              <mwe-product-icon [category]="product.category" size="md" [showText]="false" class="col-auto mt-4" />
              <div class="col">
                <mwe-headline [cssClass]="'mb-0'" [text]="'tariff.selectionCard.fernWaerme'" [headlineNodeType]="'h3'" />
                <p class="text--legal">{{ product?.category | correlatedCompanyReference }}</p>
              </div>
            </div>

            <mwe-tariff-card-waerme [product]="product" />
          </div>
        }
      </div>
    }
  }

  <div class="mb-lg-6 mb-5">
    <h2 class="mt-lg-6 mt-5 mb-4">{{ 'relocation.summary.register.personalDataTitle' | translate }}</h2>

    <mwe-basic-card
      [cardTitle]="'relocation.summary.personalData.dataTitle'"
      [iconClass]="'fa-file-user'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="relocation-summary-register-personalData"
      headingNodeType="h3"
    >
      <p class="mb-0">{{ fullNameWithTitle() }}</p>
      <p class="mb-0">{{ birthDate() }}</p>
      <p class="mb-0">{{ telefonNumberWithCountryCode() }}</p>
      <p class="mb-0">{{ email() }}</p>
      @if (idCard()) {
        <p class="mb-0">{{ idCard().type }}, {{ idCard().number }}, {{ idCard().issuer }}</p>
      }
      @if (hasFernwaermeProducts) {
        <div class="mt-3">
          <mwe-infobox messageKey="relocation.summary.personalData.dataInfoText" />
        </div>
      }
    </mwe-basic-card>

    <mwe-basic-card
      [cardTitle]="'relocation.summary.personalData.contractTitle'"
      [cardClass]="'mb-4'"
      [iconClass]="'fa-file-lines'"
      [hasBackground]="true"
      data-test="relocation-summary-register-contract"
      headingNodeType="h3"
    >
      @for (info of contractInfos; track $index) {
        @if (!$first) {
          <hr class="my-5" />
        }
        <mwe-product-summary-contract-info [showDeliveryInfos]="true" [contractInfos]="info" />
      }

      @if (hasFernwaermeProducts) {
        @if (hasContractInfos) {
          <hr class="my-5" />
        }
        <strong class="text-blue d-inline-block mb-2">{{ 'relocation.summary.personalData.fernWaermeContractTitle' | translate }}</strong>
        <p>{{ 'relocation.summary.personalData.fernWaermeContractDescription' | translate }}</p>
      }
    </mwe-basic-card>

    <mwe-basic-card
      [cardTitle]="'summary.personalBilling'"
      [iconClass]="'fa-envelope-open-text'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="relocation-summary-register-invoice"
      headingNodeType="h3"
    >
      <mwe-products-summary-invoice-old
        [isPaymentInfoVisible]="true"
        [eRechnungInfo]="eRechnungInfo()"
        [paymentIcon]="paymentIcon()"
        [paymentText]="paymentText()"
        [billingAddressTitleText]="'summary.eBillingAddress'"
        [formattedAddress]="formattedAddress()"
        [productCategories]="productCategories()"
        [infoTextCardLabel]="infoTextCardLabel()"
        [hideInvoiceAlert]="hideInvoiceAlert()"
        headlineNodeType="p"
      />
    </mwe-basic-card>
  </div>
</div>
